/* eslint-disable */
import BaseService from "../../BaseService";
const controller = "ImportCanBoCongChuc";
const { http } = BaseService();

export function Import(postdata) {
  const data = { ...postdata };
  return http({
    url: controller + "/import",
    method: "post",
    data,
  });
}

export function ImportMulti(postdata) {
  const data = [...postdata];
  // console.log(postdata);
  return http({
    url: controller + "/import-multi-cbcc",
    method: "post",
    data,
  });
}

export function ImportMultiShort(postdata) {
  const data = [...postdata];
  // console.log(postdata);
  return http({
    url: controller + "/import-multi-short-cbcc",
    method: "post",
    data,
  });
}
